import $ from "jquery";

export const sendAgainButton = () => {
    const SEND_STATUS = 'Email sent again';

    $('.send-again-btn').on('click', function () {
        if ($(this).length === 0) {
            return;
        }

        $(this).addClass('send-again-button--done');
        $(this).html(SEND_STATUS);
    });
};
